import styled from 'styled-components';
import { Card } from '../../style';

export const StyledShiftRequestsCard = styled(Card)`
  grid-column: span 6;
  display: flex;
  flex-direction: column;
  padding: 24px; /* Uniform padding with PlanCard */

  @media (max-width: 1200px) {
    grid-column: span 12;
  }
`;

export const ShiftRequestsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #5E8E7E;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 24px;
`;

export const TotalShiftsInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 42px;
      height: 42px;
    }
  }
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  span {
    display: block;
    font-size: 14px;
    color: #fff;
    opacity: 0.9;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 2px;
  }
`;

export const TotalShiftsValue = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  line-height: 1;
`;

export const DropdownWrapper = styled.div`
  position: relative;
  width: 150px;
`;

export const DropdownTrigger = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #E5E7EB; /* Added border for better definition */
  border-radius: 8px;
  padding: 8px 12px;
  color: #333;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;

  .trigger-content {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  svg {
    font-size: 16px;
    color: #666;
  }
`;

export const DropdownMenu = styled.ul`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 100%;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  padding: 8px 0;
  margin: 0;
  list-style: none;
  z-index: 100;
  overflow: hidden;
  border: 1px solid #f0f0f0;
`;

export const DropdownItem = styled.li<{ selected?: boolean }>`
  padding: 10px 16px;
  font-size: 13px;
  color: #444;
  cursor: pointer;
  transition: background 0.2s;
  background: ${({ selected }) => selected ? '#f0f4f2' : 'transparent'};
  font-weight: ${({ selected }) => selected ? '700' : '500'};

  &:hover {
    background: #f8faf9;
  }
`;

export const StatusList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
`;

export const StatusItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background: #F9FAFB; /* Off-white like PlanCard dates */
  border-radius: 12px;
  transition: all 0.2s;

  &:hover {
    background: #F3F4F6;
  }
`;

export const StatusLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  color: #4B5563;
  font-weight: 500;
`;

export const StatusDot = styled.div<{ color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
`;

export const StatusCount = styled.div`
  font-weight: 700;
  color: #1a1a1a;
  font-size: 16px;
`;

export const ViewAllWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
`;

export const ViewAllBtn = styled.button`
  padding: 10px 24px;
  background: #F3F4F6;
  color: #5E8E7E;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #5E8E7E;
    color: #fff;
  }
`;
